import { domClassMerge } from '@propertyfinder/helpers';
import { IconSpriteAreaSize, IconSpriteBathtub, IconSpriteBed, IconSpriteMapPinFilled } from '@propertyfinder/icons';
import { FunctionComponent, h } from 'preact';

import { PropertyModel } from 'common/data/property/model';
import { i18nTranslate } from 'common/helper/i18n/translate';

export const PropertyCardSectionsSpecificationsTemplate: FunctionComponent<{
  className?: string;
  disabled?: boolean;
  property: PropertyModel;
  showIcons?: boolean;
}> = ({ className, disabled, property, showIcons }) => (
  <div className={domClassMerge('card-specifications', className)}>
    <p
      className={domClassMerge('card-specifications__location', {
        'card-specifications__location--disabled': disabled,
      })}
    >
      <IconSpriteMapPinFilled className='card-specifications__icon card-specifications__icon--location' />
      <span className='card-specifications__location-text'>{property.location_tree_path}</span>
    </p>

    <div className='card-specifications__amenities'>
      {property.bedroom_value !== null && (
        <p className='card-specifications__item'>
          {showIcons && <IconSpriteBed className='card-specifications__icon' />}
          {property.bedroom_value
            ? `${property.bedroom_name} ${i18nTranslate('serp:beds', property.bedroom_value)}`
            : i18nTranslate('Studio')}
        </p>
      )}
      {property.bathroom_value > 0 && (
        <p className='card-specifications__item'>
          {showIcons && <IconSpriteBathtub className='card-specifications__icon' />}
          {property.bathroom_name} {i18nTranslate('serp:baths', property.bathroom_value)}
        </p>
      )}
      {!!property.size && (
        <p className='card-specifications__item'>
          {showIcons && <IconSpriteAreaSize className='card-specifications__icon' />}
          {property.area}
        </p>
      )}
    </div>
  </div>
);
